import { PackageType } from '__generated__/api';
export const packageTypeMap = {
  FH: PackageType.FLIGHT_HOTEL,
  HC: PackageType.HOTEL_CAR,
  FHC: PackageType.FLIGHT_HOTEL_CAR,
  FC: PackageType.FLIGHT_CAR,
  HA: PackageType.HOTEL_ACTIVITY
};